import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchColumnHeadersTypes = getApiActionTypes('FETCH_COLUMN_HEADERS');
